module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/checkbox_checked-3a3d28faf2e2b8db79f38f9b9f100f2d.svg";